const MobileIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M9 3.75H15C16.2426 3.75 17.25 4.75736 17.25 6V18C17.25 19.2426 16.2426 20.25 15 20.25H9C7.75736 20.25 6.75 19.2426 6.75 18V6C6.75 4.75736 7.75736 3.75 9 3.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path d="M7 17H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11 6H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default MobileIcon
